import React, {useRef} from 'react'
import styles from '../componentsStyles/Projects.module.css'
import {useScroll, motion, useTransform} from 'framer-motion'

const ProjectImages2 = () => {

    
  const imageRef = useRef(null);

  const {scrollYProgress} = useScroll({
    target:imageRef,
    offset: ["start end", "start start"]
  })

  const scale = useTransform(scrollYProgress, 
    [0.1, 0.4],
    [1, 1.5]
  )

  const x = useTransform(scrollYProgress,  
  [0.1, 0.55, 0.7, 1],
  ["-50%", "55%", "65%", "70%"]
  )

  const opacity = useTransform(scrollYProgress,
    [0.5, 1],[0, 1]
    )

  const leftRigth1 = useTransform(scrollYProgress, 
    [0.25, 0.50, 0.75, 1],
    ["-15%", "-10%", "-5%", "0%"]
  )
  const leftRigth2 = useTransform(scrollYProgress, 
    [0.35, 0.65, 0.85, 1],
    ["-15%", "-10%", "-5%", "0%"]
  )
  const leftRigth3 = useTransform(scrollYProgress, 
    [0.45, 0.75, 0.85, 1],
    ["-15%", "-10%", "-5%", "0%"]
  )


  return (
    <div className={styles.image}> 
        
        <div className={styles.heightContainer2} >
            
        <motion.div className={styles.desc} style={{opacity, x: 125}}>
              <h3> Task handler app </h3>
              <motion.p style={{x: leftRigth1}}> 
               Drag and drop the objectives to change the priority.
              </motion.p>
              <motion.p style={{x: leftRigth2}}>
               Every element, tasks, teams and objectives are editable.
              </motion.p>
              <motion.p style={{x: leftRigth3}}>
                The user can delete his account at any time.
              </motion.p>
            </motion.div>
            
            <div className={styles.stickyContainer} ref={imageRef}>
              <div className={styles.centerImg}>
                <motion.div className={styles.imgContainer} style={{x,scale}}>
                    <img src="./images/task-handler-3.jpg" alt="not loaded!"  />
                </motion.div>
              </div>     
            </div>
            
        </div>

    </div>
  )
}

export default ProjectImages2